import useStorage from './useStorage';

interface IndexByAny {
  [key: string]: any,
};

export interface TableStorage {
  setItem: (key:string, tableSettings:any) => Promise<void>,
  getItem: (key:string) => Promise<any|null|undefined>,
};

export default function useTableStorage(customStorageName:string|undefined=undefined) {
  const storageKey = !!customStorageName ? customStorageName : 'table-storage';

  const [tableSettings, setTableSettings] = useStorage(storageKey, {});

  const tableStorage:TableStorage = {
    setItem: (key:string, tableSettings:any) => new Promise(resolve => {
      const change:IndexByAny = {};
      change[key] = tableSettings;
      setTableSettings(change);
      resolve(tableSettings);
    }),
    getItem: (key:string) => new Promise(resolve => {
      resolve(tableSettings[key]);
    }),
  };

  return tableStorage;
}
  